export default "__VITE_ASSET__14adc36d__"